import React, { useEffect, useState } from "react";
import { fetchData } from "../../Components/common/utils";
import { NavLink, useParams } from "react-router-dom";
import MainLoader from "../../Components/MainLoader";
function AllLatestProducts() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/product/category/" + id;
      const result = await fetchData(url);

      if (result && result.data) {
        setData(result.data);
      }
      setLoading(false);
    };
    fetchApiData();
  }, [id]);

  return (
    <div className="mt-4">
      {loading && <MainLoader />}
      {data.length === 0 ? (
        <div className="container">
          <div className="text-center no-found-text">
            <h3>Sorry! No Product Found.</h3>
          </div>
        </div>
      ) : (
        <div className="container">
          <h2 className="my-3">Latest Products</h2>
          <div className="row">
            {data.map((details, index) => (
              <div className="col-md-3 mb-3" key={index}>
                <NavLink to={`/latest-product-detail/${details.id}`}>
                  <div className="card h-100">
                    <div className="card-img-wrapper">
                      <img className="latest-product-img" src={details.media[0].original_url} alt={details.title} />
                    </div>
                    <div className="card-body text-center">

                      <h6 className="card-title text-center">{details.title}</h6>
                      <p className="small product-card-description text-center">{details.short_description}</p>
                      <strong className="dollar ">{details.price}</strong>
                    </div>
                  </div>
                </NavLink>

              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default AllLatestProducts;